import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAllTeamMembers, clearTeamMembers } from '../actions';

export const useTeamMembers = () => {
  const dispatch = useDispatch();
  
  // Selectors - get state from Redux store
  const {
    teamMembers,
    teamMembersLoading,
    teamMembersError
  } = useSelector((state) => state.productionData);
  
  // Actions
  const loadTeamMembers = useCallback((projectId) => {
    dispatch(getAllTeamMembers(projectId));
  }, [dispatch]);

  const clearTeamMembersData = useCallback(() => {
    dispatch(clearTeamMembers());
  }, [dispatch]);

  return {
    // State
    teamMembers,
    teamMembersLoading,
    teamMembersError,
    
    // Actions
    loadTeamMembers,
    clearTeamMembersData
  };
};

